import { api } from "@/lib/api";

const centroid = (geom) => {
  if (!geom) return [null, null];
  const coords = geom.type === "Point" ? [geom.coordinates] : geom.type === "Polygon" ? geom.coordinates[0] : geom.type === "MultiPolygon" ? geom.coordinates[0][0] : geom.type === "LineString" ? geom.coordinates : geom.coordinates.flat(2).length ? geom.coordinates.flat(1) : [];
  if (!coords.length) return [null, null];
  const [sx, sy] = coords.reduce(([ax, ay], [x, y]) => [ax + x, ay + y], [0, 0]);
  return [(sy / coords.length).toFixed(6), (sx / coords.length).toFixed(6)];
};

const csvCell = (v) => { const s = v == null ? "" : typeof v === "object" ? JSON.stringify(v) : String(v); return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s; };

export function featuresToCsv(features) {
  const keys = [];
  features.forEach((f) => Object.keys(f.properties || {}).forEach((k) => { if (!keys.includes(k) && typeof (f.properties[k]) !== "object") keys.push(k); }));
  const header = [...keys, "centroid_lat", "centroid_lng", "geometry_type"];
  const rows = features.map((f) => { const [lat, lng] = centroid(f.geometry); return [...keys.map((k) => csvCell(f.properties?.[k])), lat, lng, f.geometry?.type].join(","); });
  return "\uFEFF" + [header.join(","), ...rows].join("\n");
}

export function download(content, filename, type) {
  const blob = new Blob([content], { type });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a"); a.href = url; a.download = filename; a.click();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
}

export function exportFeatures(features, name, format) {
  const stamp = new Date().toISOString().slice(0, 10);
  const safe = name.replace(/[^a-z0-9]+/gi, "-").toLowerCase();
  if (format === "csv") download(featuresToCsv(features), `cgland-${safe}-${stamp}.csv`, "text/csv;charset=utf-8");
  else download(JSON.stringify({ type: "FeatureCollection", name, exported_at: new Date().toISOString(), features }, null, 1), `cgland-${safe}-${stamp}.geojson`, "application/geo+json");
}

export async function fetchLayerFeatures(layer) {
  const { data } = await api.get(`/map/layers/${layer.id}/geojson`);
  const f = layer.filter;
  return f?.field && f.value != null ? data.features.filter((ft) => String(ft.properties?.[f.field] ?? "") === f.value) : data.features;
}
